<template>
    <div class="container">
        <div class="meditation-info" v-show="showContent">
            <img src="../assets/bian/meditation-banner.png" alt="" class="meditation-banner">
            <div class="info-container">
                <div class="info-main">
                    <div class="meditation-name">{{trainName}}</div>
                    <div class="meditation-time">
                        <div class="time-text">时长</div>
                        <div class="time">{{allTime}}</div>
                    </div>
                    <div class="info-text">{{trainDes}}</div>
                    <div class="start-box">
                        <div class="start" @click="go">马上参与</div>
                    </div>                    
                </div>                
            </div>
        </div>
        <div class="meditation-content" v-show="!showContent">
            <div class="pic-box">
                <video id="v1" controls="controls" :src="trainSrc" @canplay="all" @ended="end"></video>
            </div>
            <div class="train-name">{{trainName}}</div>
            <div class="control" v-if="trainName!='自由练习'">
                <img src="../assets/bian/play.png" alt="" class="play" v-show="nowControl == 'play'" @click="play" />
                <img src="../assets/bian/pause.png" alt="" class="pause" v-show="nowControl == 'pause'"
                    @click="pause" />
            </div>
        </div>
    </div>
</template>
<script>
import {meditation_details,ali_getVideo,add_train} from '../api/adjust'
export default {
    data() {
        return {
            showContent:true,
            loginPhone:'',
            unit_id:'',
            trainName:'',
            videoId:'',
            trainDes:'',
            allTime:'',
            m1:null,
            trainSrc:null,
            nowControl:'play',
            isFirst:true,
            startTime:'',
            endTime:'',
        };
    },
    computed: {},
    methods: {
        go(){
            this.showContent=false;
        },
        articleDetails(){
            meditation_details(this.unit_id).then(res=>{
                if(res.status==200){
                    this.trainName=res.data.article_name;
                    let strStart=res.data.article_txt.indexOf('<video')
                    let strEnd=res.data.article_txt.indexOf('</video>')
                    let video=res.data.article_txt.slice(strStart,strEnd+8)
                    let idStart=video.indexOf('id="')
                    let idEnd=video.lastIndexOf('" style')
                    let videoId=video.slice(idStart+4,idEnd)
                    this.videoId=videoId;
                    let desStart=res.data.article_txt.indexOf('<p>')
                    let desEnd=res.data.article_txt.indexOf('</p>')
                    let des=res.data.article_txt.slice(desStart+3,desEnd)
                    this.trainDes=des;
                    this.get_video(); 
                }
            })
        },
        get_video(){
            ali_getVideo(this.videoId).then(res=>{
                this.trainSrc=res.data.urlArr[0];
            })
        },
        all() {
            this.m1 = document.getElementById("v1");
            let audio = this.m1;
            let time = audio.duration; //获取总播放时间
            if (!time) {
                time = 0;
            }
            let minutes = parseInt(time / 60);
            if (minutes < 10) {
                minutes = "0" + minutes;
            }
            let second = Math.round(time % 60);
            if (second < 10) {
                second = "0" + second;
            }
            let allTime = minutes + ":" + second;
            this.allTime = allTime;
        },
        play(){
            if (this.isFirst) {
                let date = new Date();
                let time = parseInt(date.getTime() / 1000)
                this.startTime = time;
            }
            this.isFirst = false;
            this.m1.play();
            this.nowControl = "pause";
        },
        pause(){
            this.m1.pause();
            this.nowControl = "play";
        },
        end() {
            this.m1.pause();
            this.nowControl = "play";
            let date = new Date();
            let time = parseInt(date.getTime() / 1000)
            this.endTime = time;
            add_train(this.loginPhone,this.startTime, this.endTime, 'train', this.trainName).then(res => {
                if (res.status == 200) {
                    this.$router.push({ path: '/meditation-report', query: { id: res.data.trainData[0].id } })
                }
            })
        }      
    },
    created() {
        let phone=localStorage.getItem('phone')
        this.loginPhone=phone;
        this.unit_id=this.$route.query.id; 
        this.articleDetails()
    },
};
</script>
<style lang='less' scoped>
.container{
    min-height: 100vh;
    background-image: linear-gradient(to bottom, #E9FAF5, #F4FFF8); 
}
.meditation-info{
    height: 100vh;
}
.meditation-banner{
    width: 100%;
    position: relative;
}
.info-container{
    position: absolute;
    bottom: 0px;
    left: 0px;
    background-color: #fff;
    width: 100%;
    height: 68vh;
    border-radius: 40px 40px 0px 0px;
}
.info-main{
    padding: 40px 16px;
}
.meditation-name{
    line-height: 40px;
    font-size: 24px;
    color: #000000;
    font-weight: bold;
    padding-bottom: 10px;
}
.meditation-time{
    height: 48px;
    display: flex;
    justify-content: space-between;
    background-color: #F6F7FB;
    padding: 0px 16px;
}
.time-text{
    height: 48px;
    line-height: 48px;
    font-size: 14px;
    color: #969696;
    font-weight: 500;
}
.time{
    height: 48px;
    line-height: 48px;
    font-size: 14px;
    color: #333;
    font-weight: bold;
}
.info-text{
    padding-top: 27px;
    line-height: 24px;
    color: #969696;
    font-weight: 500;
}
.start-box{
    position: fixed;
    left: 0px;
    bottom: 0px;
    width: 100%;
    z-index: 10;
    padding-bottom: 20px;
    background-color: #fff;
}
.start{
    height: 52px;
    border-radius: 26px;
    background-image: linear-gradient(to right, #00C8BD, #40D2DA);  
    text-align: center;
    line-height: 52px;
    color: #fff;
    font-size: 16px;
    font-weight: 500;
    margin: 0px 15px;
}
.meditation-content{
    padding-top: 140px;
}
.pic-box{
    width: 300px;
    height: 220px;
    padding:10px;
    margin: 0px auto 30px;
    background-image: linear-gradient(to right bottom, #262324, #797879 );
    border-radius:10px;
}
.train-name{
    height: 40px;
    line-height: 40px;
    text-align: center;
    color: #2E2E2E;
    font-weight: bold;
    font-size: 24px;
    padding-bottom: 90px;
}
.control {
    height: 60px;
    margin-top: 40px;
}
.play {
    display: block;
    height: 60px;
    width: 60px;
    border-radius: 50%;
    margin: 0 auto;
}
.pause {
    display: block;
    height: 60px;
    width: 60px;
    border-radius: 50%;
    margin: 0 auto;
}
#v1{
    width: 300px;
    height:220px;
}
</style>